import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { people, Profile, svg } from "../../config/imagesLink";
import { IoIosArrowDown } from "react-icons/io";
import CreateCompany from "../CreateCompany/CreateCompany";
import { GetProfileInfo } from "../../Services/Service";
import axios, { IMAGE_URL } from "../../API/axios";
import { getOwnCompaniesList, getUserConfig } from "../../Services/apiService";
import ViewAll from "./ViewAll";
import Blogs from "../Blogs/Blogs";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
// import work from "../assets/Images/svg/icon_work";
import HomeSharpIcon from '@mui/icons-material/HomeSharp';
import EditNoteSharpIcon from '@mui/icons-material/EditNoteSharp';
import HubSharpIcon from '@mui/icons-material/HubSharp';
import BusinessSharpIcon from '@mui/icons-material/BusinessSharp';
import NotificationsSharpIcon from '@mui/icons-material/NotificationsSharp';
import AddBusinessSharpIcon from '@mui/icons-material/AddBusinessSharp';
import WorkSharpIcon from '@mui/icons-material/WorkSharp';
import WorkHistorySharpIcon from '@mui/icons-material/WorkHistorySharp';
import FeedSharpIcon from '@mui/icons-material/FeedSharp';
import RssFeedSharpIcon from '@mui/icons-material/RssFeedSharp';
import ContactSupportSharpIcon from '@mui/icons-material/ContactSupportSharp';
import SettingsAccessibilitySharpIcon from '@mui/icons-material/SettingsAccessibilitySharp';
import GavelSharpIcon from '@mui/icons-material/GavelSharp';
import LaunchSharpIcon from '@mui/icons-material/LaunchSharp';
import PhoneIcon from '@mui/icons-material/Phone';
import CopyrightSharpIcon from '@mui/icons-material/CopyrightSharp';
import PersonSearchSharpIcon from '@mui/icons-material/PersonSearchSharp';
import PrivacyTipSharpIcon from '@mui/icons-material/PrivacyTipSharp';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import AdminPanelSettingsSharpIcon from '@mui/icons-material/AdminPanelSettingsSharp';
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import MyCompanies from "../MyCompanies/MyCompanies";
import { useTranslation } from "react-i18next";

const { work } = svg;

const LeftNavigation = ({
  isOpen,
  toggleMenu,
  data,
  // profileConfig,
  // setProfileConfig,
  setIsOpen,
  openModal,
  showModal,
  closeModal,
}) => {
  const UpdateLeftNavigationUserData = () => { };

  const sessionId = localStorage.getItem("sessionId");
  const guestModeData = localStorage.getItem("guestMode");
  const ProfilePercent = localStorage.getItem("ProfilePercentage"); 
  const language = localStorage.getItem("Lang");

  // const profilPic = localStorage.getItem("profilPic");
  const userUid = localStorage.getItem("userUid");
  const usernameTag = localStorage.getItem("user-nameTag");
  const firstName = localStorage.getItem("firstName");
  const lastName = localStorage.getItem("lastName");
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const [profileData, setProfileData] = useState();
  // const [ownCompanyList, setOwnCompanyList] = useState([]);
  const [ownCompanyList, setOwnCompanyList] = useState(() => {
    const saved = localStorage.getItem("OwncompanyList");
    return saved ? JSON.parse(saved) : [];
  });


  const [profilPic, setProfilPic] = useState(localStorage.getItem("profilPic"));

  useEffect(() => {
    const handleProfilePicUpdate = (event) => {
      setProfilPic(event.detail);
    };

    window.addEventListener('profilePicUpdated', handleProfilePicUpdate);

    return () => {
      window.removeEventListener('profilePicUpdated', handleProfilePicUpdate);
    };
  }, []);


  //************************ Get Own Companies List  ************************//
  const [loading, setLoading] = useState(true);
  const [UpdateList, setUpdateList] = useState(false);

  const GetOwnCompniesListsData = async () => {
    // console.log('hitted');
    try {
      const Response = await getOwnCompaniesList();
      // console.log('GetOwnCompniesListsData', Response);
      setOwnCompanyList(Response);
      localStorage.setItem("OwncompanyList", JSON.stringify(Response));

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  
  // useEffect(() => {
  //   const sessionId = localStorage.getItem("sessionId");
  //   if (sessionId) {
  //     GetOwnCompniesListsData();
  //   }
  // }, [sessionId]);
  // console.log('hitted', UpdateList);
  // console.log("guestModeData===>", data);

  //************************  Get Own Companies List End  ************************//
  // const renderTooltip = (props) => (
  //   <Tooltip id="button-tooltip" {...props}>
  //     Sign In required
  //   </Tooltip>
  // );
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props} className="custom-tooltip">
      Sign In required
    </Tooltip>
  );


  const location = useLocation();

  const handleLogoClick = () => {
    if (location.pathname === "/NewsFeed") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };


  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);

  const [profileConfig, setProfileConfig] = useState("");
  const userConfig = async () => {
    try {
      const responseData = await getUserConfig();
      console.log('profileconfig000000', responseData);
      setProfileConfig(responseData);
    } catch (error) {
      //  if ((error.code === 'ERR_NETWORK' && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
      //   setUnauthorisedModal(true)
      // }
    }
  };
console.log("profileConfig", profileConfig.hasCcv);

   useEffect(() => {
            const sessionId = localStorage.getItem("sessionId");
  
        if (sessionId) {
          (async () => {  
            await Promise.all([ 
              userConfig(),
              GetOwnCompniesListsData()

            ]);
          })();
        } 
        }, [sessionId]);

  // console.log("profileconfig000000", profileConfig);
  
  const [showResumeModal, setShowResumeModal] = useState(false);
  const onEvent = () => {
    (profileConfig.hasCcv === null || profileConfig.hasCcv === false) &&
      ProfilePercent < 60
      ? setShowResumeModal(!showResumeModal)
      : openModal()
        toggleMenu()

  };

  // -------------------------------------------------------
  const hasCompany = ownCompanyList?.length > 0;
  // -------------------------------------------------------
  return (
    <>
      <div className={`menu ${isOpen ? "open" : ""}`}>
        <div className="sideLinks leftNav">
          <div className="text-end ToggleClose" onClick={toggleMenu}>
            <CloseSharpIcon className="material-symbols-sharp" />

          </div>
          {guestModeData === "true" ? (
            <NavLink to="/SignIn" onClick={toggleMenu}>
              <div className="personal d-flex align-items-center px-3 py-2">
                <img
                  src={people.DefaultProfile}
                  width={40}
                  height={40}
                  alt=""
                  style={{ borderRadius: "50px" }}
                />
                <div className="ms-2">
                  <h5 className="f-12 mb-0 fw-bold">
                    <div>Guest Mode</div>

                    <p className="f-10 mt-1 sign-up-text">Sign Up Now</p>
                  </h5>
                </div>
              </div>
            </NavLink>
          ) : (
              <Link
                to={`/User/${userUid}`}
                className="d-flex align-items-center UserImageRes personal"
                // onClick={toggleMenu}
                onClick={() => {
                  toggleMenu();
                  window.scrollTo({ top: 0, behavior: "smooth" });  
                }}
               >
              <div className=" d-flex align-items-center px-3 py-2">
                <img
                  src={`${profilPic}`}
                  width={40}
                  height={40}
                  alt=""
                  style={{ borderRadius: "50px" }}
                />

                <div className="ms-2">
                  <h5 className="f-12 mb-0 fw-bold name-content">
                    {firstName} {lastName}
                    {/* {lastName.length > 16 ? `${lastName.substring(0, 16)}...` : lastName} */}
                  </h5>
                  {/* <span className="f-12">{usernameTag}</span> */}
                  <span className="f-12 email-content">
                    {usernameTag?.length > 16 ? `${usernameTag?.substring(0, 16)}...` : usernameTag}
                  </span>

                </div>
              {/* <div className="dropdown ms-auto">
                <IoIosArrowDown />
              </div> */}
            </div>
              </Link>

          )}

          <ul className="ps-0 listLink rightlist">
            <NavLink
              to="/NewsFeed"
              onClick={() => {
                toggleMenu();
                handleLogoClick();
              }}
            >
              <li className="navLinks">
                <HomeSharpIcon />
                {/* <span>News Feeds</span> */}
                <span>{t("Sidemenubar.NewsFeeds")}</span>
              </li>
            </NavLink>
            {guestModeData === "true" ? (
              ""
            ) : (
              <NavLink to="/Draft" onClick={toggleMenu}>
                <li className="navLinks">
                  <EditNoteSharpIcon />
                  {/* <span>Drafts</span> */}
                   <span>{t("Sidemenubar.Drafts")}</span>
                </li>
              </NavLink>
            )}

            {guestModeData === "true" ? (
              <li className="navLinks">
                <HubSharpIcon className="GuestMode" />
                <OverlayTrigger
                  placement="right" // or 'bottom', 'right', etc.
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip}
                >
                  {/* <span className="GuestMode"> Connections </span> */}
                  <span className="GuestMode">{t("Sidemenubar.Connections")}</span>
                </OverlayTrigger>
              </li>
            ) : (
              <NavLink to="/Connections" onClick={toggleMenu}>
                <li className="navLinks">
                  <HubSharpIcon />
                  {/* <span>Connections</span> */}
                  <span>{t("Sidemenubar.Connections")}</span>

                </li>
              </NavLink>
            )}
            <NavLink to="/People" onClick={toggleMenu}>
              <li className="navLinks">
                <PersonSearchSharpIcon />
                {/* <span>People</span> */}
                <span>{t("Sidemenubar.People")}</span>
              </li>
            </NavLink>

            {guestModeData === "true" ? (
              <li className="navLinks">
                <WorkHistorySharpIcon className="GuestMode" />

                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip}
                >
                  {/* <span className="GuestMode"> Manage Job </span> */}
                <span className="GuestMode">{t("Sidemenubar.Manage Job")}</span>

                </OverlayTrigger>
              </li>

            ) : (
              <NavLink to="/ManageJobs" onClick={toggleMenu}>
                <li className="navLinks">
                  <WorkHistorySharpIcon />
                  {/* <span>Manage Job</span> */}
                <span >{t("Sidemenubar.Manage Job")}</span>

                </li>
              </NavLink>
            )}
            <NavLink to="/Companies" onClick={toggleMenu}>
              <li className="navLinks">
                <BusinessSharpIcon />
                {/* <span>Companies</span> */}
                <span  >{t("Sidemenubar.Companies")}</span>

              </li>
            </NavLink>
            {guestModeData === "true" ? (
              <li className="navLinks">
                <AddBusinessSharpIcon className="GuestMode" />

                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip}
                >
                  <span className="GuestMode">
                    {t("Sidemenubar.Create Company")}
                  </span>
                </OverlayTrigger>
              </li>
            ) : (
              <>
                {loading ? (
                  ""
                ) : ownCompanyList && ownCompanyList.length >= 1 ? (
                  ""
                ) : (
                  <li className="navLinks pointer" onClick={onEvent}>
                    <AddBusinessSharpIcon />
                    <span className="ms-1">{t("Sidemenubar.Create Company")} </span>
                  </li>
                )}
              </>
            )}


              {guestModeData === "true" ? (
                <>
                 <li className="navLinks">
                  <NotificationsSharpIcon className="GuestMode" />
                   <OverlayTrigger
                      placement="right"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip} > 
                    <span className="GuestMode" >{t("Sidemenubar.Job Applications")}</span>
                   </OverlayTrigger>
                   </li>
                </>
              ) : (
                <>
                  {loading ? (
                    <>
                    <li className="navLinks">    
                      <NotificationsSharpIcon className="opacity-50" /> 
                      <span className="opacity-50" >{t("Sidemenubar.Job Applications")}</span>
                      </li>
                    </>
                  ) :
                    ownCompanyList && ownCompanyList.length >= 1 ? (
                      <NavLink to="/JobApplications" onClick={toggleMenu} className="navLinks d-flex align-items-center">
                         <li className=" ">
                           <NotificationsSharpIcon /> 
                          <span >{t("Sidemenubar.Job Applications")}</span>
                          </li>
                      </NavLink>
                    ) : (
                      <>
                         <li className="navLinks">
                            <NotificationsSharpIcon className="opacity-50" />
                            <span className="opacity-50" >{t("Sidemenubar.Job Applications")}</span> 
                        </li>
                      </>
                    )}
                </>
              )} 


            <NavLink to="/SearchJob" onClick={toggleMenu}>
              <li className="navLinks">
                 <WorkSharpIcon /> 
                <span>{t("Sidemenubar.Search Job")}</span>
              </li>
            </NavLink>

          </ul>

          {guestModeData !== "true"  && hasCompany && (
            <div className="hashtags p-0 main-center-manage">
              <div className=" d-flex  align-items-center sidebar-center-manage mb-2">
                <h4 className="heading mb-0 me-2">
                   <span  >{t("Sidemenubar.My Companies")}</span>
                    {/* My Companies */}
                </h4>
                <NavLink
                  className="f-12 d-flex justify-content-center main-Manage-area"
                  to={`/MyCompanies`}
                  onClick={toggleMenu}
                >
                  {/* Manage */}
                  {t("Sidemenubar.Manage")}
                </NavLink>
              </div>


              <ul className="ps-0 listLink rightlist">
                {ownCompanyList &&
                  ownCompanyList
                    .filter(item => item.isDeleted === false) // filter out deleted ones
                    .slice(0, 3)
                    .map((item, index) => (
                      <NavLink to={`/Company/${item.compUid}/${item.slug}`} key={index} onClick={toggleMenu}>
                        <li className="navLinks d-flex align-items-center">
                          <img
                            src={item?.logoImage}
                            alt=""
                            width="25"
                            height="25"
                            style={{ borderRadius: "50px" }}
                          />
                          <span>{item.compName}</span>
                        </li>
                      </NavLink>
                    ))}
              </ul>

            </div>

          )}

          <ul className="ps-0 pb-5 listLink rightlist">
            <NavLink to="/Blogs" target="_blank">
              <li className="navLinks">
                <FeedSharpIcon />
                 <span  >{t("Sidemenubar.Blogs")}</span>
                {/* <span>Blogs</span> */}
              </li>
            </NavLink>

            <NavLink to="/aboutus.html#contactform" target="_blank">
              <li className="navLinks">
                <PhoneIcon />
                 <span  >{t("Sidemenubar.Contact Us")}</span>
                {/* <span>Contact Us</span> */}
              </li>
            </NavLink>

            <NavLink to="/aboutus.html" target="_blank">
              <li className="navLinks">
                <RssFeedSharpIcon />
                 <span>{t("Sidemenubar.About Us")}</span>
                {/* <span>About</span> */}
              </li>
            </NavLink>
            <NavLink to="/faq.html" target="_blank">
              <li className="navLinks">
                <ContactSupportSharpIcon />
                 <span>{t("Sidemenubar.Faqs")}</span>
                {/* <span>Faqs</span> */}
              </li>
            </NavLink>
            <NavLink to="/user-agreement.html" target="_blank">
              <li className="navLinks">

                <SettingsAccessibilitySharpIcon />
                {/* <span>User Agreement</span> */}
               <span>{t("Sidemenubar.User Agreement")}</span>
              </li>
            </NavLink>

            <NavLink to="/privacy-policy.html" target="_blank">
              <li className="navLinks">
                <AdminPanelSettingsSharpIcon />
                <span>{t("Sidemenubar.Privacy Policy")}</span>
                {/* <span>Privacy Policy</span> */}
              </li>
            </NavLink>

            <NavLink to="/terms-and-conditions.html" target="_blank">
              <li className="navLinks">
                <GavelSharpIcon />
                <span>{t("Sidemenubar.Terms & Conditions")}</span>
                {/* <span>Terms & Conditions</span> */}
              </li>
            </NavLink>

            <NavLink to="/downlaodapp.html" target="_blank">
              <li className="navLinks">
                <LaunchSharpIcon />
                {/* <span>Get the Welinkjobs App</span> */}
                <span>{t("Sidemenubar.Get the Welinkjobs App")}</span>
              </li>
            </NavLink>
            {/* <NavLink to="/"> */}
            <li className="navLinks">
              <CopyrightSharpIcon />
             <span>{t("Sidemenubar.Welinkjobs 2024")}</span>
              {/* <span>Welinkjobs 2024</span> */}
            </li>
          </ul>
        </div>
      </div>



      {showResumeModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Please complete your profile up to 60% and must have valid resume to  Create Company")} </h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setShowResumeModal(false);
                  }}
                />
              </div>
              <div className="text-center mt-2">
                <Link to={`/User/${userUid}`}>
                  <button
                    color=""
                    className="closebtn"
                    style={{ width: "150px" }}
                    // onClick={() => {
                    //   userCcv !== "True" && AddUserCcv();
                    // }}
                    onClick={() => {
                      setShowResumeModal(false);
                    }}
                  >
                     {t("Newsfeed.Manage Profile")}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
      <div className="d-none">
        <MyCompanies
        userConfig={userConfig}
        profileConfig={profileConfig}
        setProfileConfig={setProfileConfig} 
          // GetOwnCompniesListsData={GetOwnCompniesListsData}
          setUpdateList={setUpdateList}
          hasCcv={profileConfig.hasCcv}
        />
      </div>

      {unauthorisedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="d-flex justify-content-between align-items-center p-2">
                <div>
                  <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                  <p className="text-center ad-p">
                    {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")}
                  </p>
                  <div className="text-center m-auto mt-3">
                    <button
                      type="button"
                      className="mainBtn1 "
                      onClick={() => {
                        setUnauthorisedModal(!unauthorisedModal)
                        navigate("/SignIn");
                        localStorage.clear();
                        sessionStorage.removeItem('hasModalShown');
                      }}
                    >
                      {t("modals.login")} 
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LeftNavigation;